import React, {useEffect, useReducer} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from "react-redux";

import ButtonBack from './ButtonBack';
import ButtonRight from './ButtonNext';

import './pd-tool-bar.scss';


function ProgressToolBar({getRefComponents}) {
    const me = useSelector(state => state.me);
    const stream = useSelector(state => state.stream);
    const current_index = useSelector(state => state.student_stream_current_index);
    const [, forceUpdate] = useReducer(x => x + 1, 0);

    //TODO is it necessary?
    useEffect(() => {
        if (me) {
            let user_channel = pusher.channel('user_' + me.id);
            if (!user_channel || !user_channel.subscribed) {
                user_channel = pusher.subscribe('user_' + me.id);
            }
            user_channel.bind('user.updated', () => {
                forceUpdate();
            });
        }

        return () => {
            let user_channel = pusher.channel('user_' + me.id);
            if (user_channel && user_channel.subscribed) {
                user_channel.unbind('user.updated', () => {
                });
            }
        }
    }, [me]);

    const renderBackButton = () => {
        if (stream.lesson.mode === 'teacher') {
            return null;
        }

        return (
            <ButtonBack
            />
        );
    }

    return (
        <div className="pd-tool-bar flex-row flex-h-center flex-gap-20">
            {renderBackButton()}

            <ButtonRight
                getRefComponents={getRefComponents}
            />
        </div>
    );
}

ProgressToolBar.propTypes = {
    getRefComponents: PropTypes.func.isRequired
}

export default ProgressToolBar
